/* eslint-disable */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en_US from './en_US';
import zh_CN from './zh_CN';

Vue.use(VueI18n);

const messages = {
  en_US,
  zh_CN,
};

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en_US',
  messages,
});

export default i18n;
